import api from "./api";

const getLedgers = async () => {

    const response = await api.get("/api/ledgers");

    return response.data.data;

};

const addLedger = async(formData)=>{
    const response = await api.post(
        "/api/ledgers",
        formData
    );

    return response.data;

}

const updateLedger = async(id,formData)=>{

    const response = await api.put(
        `/api/ledgers/${id}`,
        formData
    );

    return response.data;

}

const deleteLedger = async(id)=>{

    const response = await api.delete(`/api/ledgers/${id}`);

    return response.data;

}

export default{
    getLedgers,
    addLedger,
    updateLedger,
    deleteLedger
}